import { useRef, useState } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { insert, without } from 'ramda'
import { Box, Button, ButtonIcon, IconClose } from '@machobear/design-system'

import { Label } from '@/components/text'
import useOnClickOutside from '@/components/use-onclick-outside'

import { FilterWrapper } from '../elements'
import FurnishingCheckbox from '../furnishing-checkbox'
import { handleDataLayerEvent } from '../utils'

const StyledFilterWrapper = styled(FilterWrapper)`
  width: fit-content;
  margin-top: 8px;
  ${props => props.isExt && 'right: 0;'}
`

const FurnishingFilter = ({
  features = [],
  onChange,
  clickOutsideCallback,
  close,
  isExt
}) => {
  const { t } = useTranslation()
  const FurnishingFilterRef = useRef()
  useOnClickOutside(FurnishingFilterRef, e => clickOutsideCallback(e))
  const [values, setValues] = useState(features)

  const handleFeatureChange = e => {
    handleDataLayerEvent('furnishing')
    const id = e.target.id
    const checked = e.target.checked
    const filter = checked ? insert(0, id, values) : without([id], values)
    return setValues(filter)
  }

  return (
    <div ref={FurnishingFilterRef}>
      <StyledFilterWrapper isExt={isExt}>
        <Box
          display="flex"
          flexDirection="column"
          padding="small"
          style={{ gap: '24px' }}
        >
          <Box display="flex" justifyContent="spaceBetween">
            <Label type="medium">
              {t(
                'filters:b.listing_filter.edit.furnishing.label',
                'Furnishing'
              )}
            </Label>
            <ButtonIcon
              icon={<IconClose />}
              onClick={close}
              variant="transparent"
              tone="secondary"
            />
          </Box>
          <FurnishingCheckbox onChange={handleFeatureChange} values={values} />
        </Box>
        <Box
          display="flex"
          justifyContent="spaceBetween"
          padding="small"
          background="neutralSoft"
          borderTop="borderNeutralLight"
        >
          <Box style={{ maxWidth: 'fit-content' }}>
            <Button
              variant="transparent"
              size="small"
              onClick={() => {
                const withoutFurnishingFilters = values.filter(
                  val => val !== 'furnished' && val !== 'unfurnished'
                )
                setValues(withoutFurnishingFilters)
              }}
            >
              {t('Clear')}
            </Button>
          </Box>
          <Box style={{ maxWidth: 'fit-content' }}>
            <Button onClick={() => onChange({ features: values })} size="small">
              {t('common.save', 'Save')}
            </Button>
          </Box>
        </Box>
      </StyledFilterWrapper>
    </div>
  )
}

export default FurnishingFilter
